import { useFormik } from "formik";
import PropTypes from "prop-types";
import React from "react";
import { withTranslation } from "react-i18next";
import { useHistory, withRouter } from "react-router";
import { Link } from "react-router-dom";
import { toast } from "react-toastify";
import { Col, Container, Form, FormFeedback, Input, Row } from "reactstrap";
import * as Yup from "yup";

import { getTicketInitialValue, Ticket } from "src/sdk/models/Ticket";
import { TicketService } from "src/services/TicketService";

export interface CreateTicketSuperAdminProps { }

const service = new TicketService();
export const CreateTicketSuperAdmin: React.FC<CreateTicketSuperAdminProps> = () => {
    const history = useHistory();

    const validation = useFormik<Ticket>({
        enableReinitialize: true,
        initialValues: getTicketInitialValue(),
        validationSchema: Yup.object({
            subject: Yup.string().required("Subject is required"),
            facilityName: Yup.string().required("Facility Name is required"),
            priority: Yup.string().required("Priority is required"),
            category: Yup.string().required("Category is required"),
        }),
        onSubmit: (values) => {
            console.log(values);
            service.createTicket(values)
                .then((res: any) => {
                    console.log(res)
                    toast.success(`Ticket "${values.subject}" created successfully`);
                    history.push("/admin-ticketing");
                })
                .catch((err: any) => {
                    console.error(err);
                    toast.error("Error while creating ticket");
                });
        },
    });

    return (
        <React.Fragment>
            <Form
                onSubmit={(e) => {
                    e.preventDefault();
                    validation.handleSubmit();
                    return false;
                }}
            >
                <Container fluid>
                    <div className="row">
                        <div className="col-12">
                            <div style={{ paddingTop: 10, paddingBottom: 20, display: "flex", flexDirection: "row" }}>
                                <Link style={{ color: "black" }} to="/ticketing">
                                    <h5>Ticketing</h5>
                                </Link>
                                <i className="bi bi-chevron-right" />
                                <h5 style={{ marginLeft: 13, opacity: 0.6 }}>Create Ticket</h5>
                            </div>
                        </div>
                    </div>

                    {[
                        { name: "facilityName", label: "Facility Name", required: true },
                        { name: "facilityGroupName", label: "Facility Group" },
                        { name: "filemakerUUID", label: "Filemaker UUID" },
                        { name: "status", label: "Status" },
                        { name: "priority", label: "Priority", required: true, type: "select", options: ["Low", "Medium", "High"] },
                        { name: "radiologist", label: "Radiologist" },
                        { name: "category", label: "Category", required: true },
                        { name: "subCategory", label: "Sub-Category" },
                        { name: "contact", label: "Contact" },
                        { name: "supportArea", label: "Support Area" },
                        { name: "createdBy", label: "Created By" },
                        { name: "subject", label: "Subject", required: true },
                        { name: "description", label: "Description", type: "textarea" },
                    ].map(({ name, label, required, type = "text", options }) => (
                        <Row key={name}>
                            <Col lg={4} md={5} className="col-xxl-2 p-2">
                                <h5>{label}:</h5>
                            </Col>
                            <Col lg={4} md={5} className="col-xxl-10">
                                {type === "select" ? (
                                    <Input
                                        type="select"
                                        name={name}
                                        className="form-control"
                                        value={(validation.values as any)[name]}
                                        onChange={validation.handleChange}
                                        onBlur={validation.handleBlur}
                                        invalid={!!(validation.touched[name as keyof Ticket] && validation.errors[name as keyof Ticket])}
                                    >
                                        <option value="">Select {label.toLowerCase()}</option>
                                        {options?.map((opt) => (
                                            <option key={opt} value={opt}>{opt}</option>
                                        ))}
                                    </Input>
                                ) : type === "textarea" ? (
                                    <Input
                                        id={name}
                                        name={name}
                                        className="form-control"
                                        placeholder={`Enter ${label.toLowerCase()}`}
                                        type="textarea"
                                        rows={6}
                                        value={(validation.values as any)[name]}
                                        onChange={validation.handleChange}
                                        onBlur={validation.handleBlur}
                                        invalid={!!(validation.touched[name as keyof Ticket] && validation.errors[name as keyof Ticket])}
                                    />
                                ) : (
                                    <Input
                                        id={name}
                                        name={name}
                                        className="form-control"
                                        placeholder={`Enter ${label.toLowerCase()}`}
                                        type="text"
                                        value={(validation.values as any)[name]}
                                        onChange={validation.handleChange}
                                        onBlur={validation.handleBlur}
                                        invalid={!!(validation.touched[name as keyof Ticket] && validation.errors[name as keyof Ticket])}
                                    />
                                )}

                                {required && validation.touched[name as keyof Ticket] && validation.errors[name as keyof Ticket] && (
                                    <FormFeedback>{validation.errors[name as keyof Ticket]}</FormFeedback>
                                )}
                            </Col>
                        </Row>
                    ))}
                </Container>

                <Container fluid>
                    <div className="d-flex flex-row-reverse">
                        <div className="p-1">
                            <button
                                className="btn btn-primary btn-block"
                                style={{ border: 0, backgroundColor: "#95CBB2", color: "#FFFFFF" }}
                                type="submit"
                            >
                                Save
                            </button>
                        </div>
                        <div className="p-1">
                            <Link className="btn btn-secondary btn-block" to="/ticketing">
                                Cancel
                            </Link>
                        </div>
                    </div>
                </Container>
            </Form>
        </React.Fragment>
    );
};

CreateTicketSuperAdmin.propTypes = {
    location: PropTypes.object,
    t: PropTypes.any,
};

export default withTranslation()(withRouter(CreateTicketSuperAdmin));

